export const data = function() {
  return {
    isDebug: true,
    loading: false,
    workOrderRequestID: 0,
    workOrderRequest: null,
    tabs: [
      { name: 'workorderRequestDetail', label: 'Request Detail' },
      { name: 'workorderRequestConversation', label: 'Conversations' }
    ],
    styles: {
      mainContainer: {
        minHeight: '1000px'
      }
    },
    transitionName: 'slide-down',
    showUploadModal: false
  }
}
